document.addEventListener('click', function (e) {
  var toggle = e.target.closest('.menu-toggle');
  if (!toggle) return;
  var open = toggle.getAttribute('aria-expanded') === 'true';
  toggle.setAttribute('aria-expanded', String(!open));
  document.querySelector('.site-header').classList.toggle('site-header--open', !open);
});
document.addEventListener('click', function (e) {
  var link = e.target.closest('.site-header .nav a');
  if (!link) return;
  var t = document.querySelector('.menu-toggle');
  if (t) t.setAttribute('aria-expanded', 'false');
  document.querySelector('.site-header').classList.remove('site-header--open');
});
